import React from "react";
import { Button } from "../bootstrap/index.jsx";

const Modal = ({
  id,
  size,
  fullHeight = false,
  title,
  children,
  onClose,
  onSave,
  saving,
  disableSave = false,
  focusOnMount = false,
  saveLabel = I18n.t("save"),
  cancelLabel = I18n.t("cancel"),
  cssClassNameCancelButton = "pull-left",
  hideButtons = false,
  hideSaveButton = false,
  hideCloseButton = false,
  modalContainerClassName = '',
  modalStyle = {},
  modalClassName = '',
  style = {}
}) => {
  const rootRef = React.useRef();

  React.useEffect(() => {
    jQuery(rootRef.current)
      .modal()
      .off("hidden.bs.modal")
      .on("hidden.bs.modal", (event) => {
        if (typeof onClose == "function") {
          onClose();
        }
      })
      .off("shown.bs.modal")
      .on("shown.bs.modal", (event) => {
        if (focusOnMount) {
          const input = rootRef.current.querySelector("input");
          if (input) {
            input.focus();
          }
        }
      });

    return () => {
      jQuery(rootRef.current).off("hidden.bs.modal").off("shown.bs.modal");
    };
  }, []);

  const resize = () => {
    if (fullHeight && rootRef.current) {
      const root = jQuery(rootRef.current);
      const dialog = root.find(".modal-dialog");
      const body = dialog.find(".modal-body");

      const height =
        visualViewport.height -
        dialog.find(".modal-header").outerHeight(true) -
        dialog.find(".modal-footer").outerHeight(true) -
        (dialog.outerHeight(true) - dialog.height()) -
        (body.outerHeight(true) - body.height()) -
        10;

      body.height(height);
    }
  };

  const debouncedResize = _.debounce(resize, 300);

  React.useEffect(() => {
    debouncedResize();

    jQuery(window).on("resize", resize);

    return () => {
      jQuery(window).off("resize", resize);
    };
  });

  return (
    <div
      ref={rootRef}
      id={id}
      className={`modal fade ${modalContainerClassName}`}
      data-backdrop="static"
      tabIndex="-1"
      role="dialog"
    >
      <div className={`${modalClassName} modal-dialog` + (size ? " modal-" + size : "")} style={modalStyle} role="document">
        <div className="modal-content">
          <div className="modal-header d-block">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label={I18n.t("close")}
            >
              <span aria-hidden="true" className="glyphicon glyphicon-remove"></span>
            </button>
            <h4 className="modal-title" id="dialog-label" dangerouslySetInnerHTML={{__html: title}} />
          </div>
          <div className="modal-body" style={style}>{children}</div>
          {!hideButtons ? (
            <div className="modal-footer">
              {!hideCloseButton && <Button type="default" className={cssClassNameCancelButton} data-dismiss="modal">
                {cancelLabel}
              </Button>}
              {!hideSaveButton && <Button disabled={saving || disableSave} onClick={onSave}>
                {saving ? I18n.t("loading") : saveLabel}
              </Button>}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

const closeModal = (modalId) => jQuery(`#${modalId}`).modal("hide");

export { Modal, closeModal };
